<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <note-form
    v-else
    :initDocumentation="initDocumentation"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import {defineComponent, onBeforeMount, ref} from 'vue'

import {useHTTP} from '@/plugins/http'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import NoteForm from '@/views/customers/notes/NoteForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import {useRoute, useRouter} from 'vue-router'
import Documentation from '@/models/customer/Documentation'

export default defineComponent({
  name: 'note-edit',
  components: {
    LoadingSpinner,
    NoteForm,
    AlertBadge
  },
  setup() {
    const initDocumentation = ref(new Documentation())
    const error = ref({title: '', body: ''})
    const http = useHTTP()
    const loading = ref(true)
    const route = useRoute()
    const router = useRouter()

    onBeforeMount(async () => {
      const url = `${Documentation.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Documentation>(url)
        initDocumentation.value = Documentation.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (documentation: Documentation, pin?: string) => {
      try {
        const url = `${Documentation.ENDPOINT}/${documentation.id}`
        const headers: Record<string, string> = {}
        if (pin) headers.pin = pin
        await http.put<Documentation>(url, documentation, { headers })
        router.back()
      } catch (error) {
        return error
      }
    }

    return {
      initDocumentation,
      error,
      loading,
      update
    }
  }
})
</script>
